import React from 'react';
import ServicePage from '../components/ServicePage';
import img from '../assets/service7_1.jpeg';

const overview = [
  'Client Virtualisation Solutions enabling secure, seamless computing from anywhere for the workforce.',
  'Power Computing & End-User Devices including workstations, advanced compute solutions for AI & Data Science, thin clients, laptops, desktops, and Chromebooks, with Windows and iOS options.',
  'Point of Sale (POS) & Device as a Service (DaaS) solutions for simplified device procurement, deployment, and operations.',
  'Print & Workflow Solutions covering plotting, printing, scanning, multifunction devices, and Managed Print Services (MPS).',
  'Mobility, Client & Application Management, along with implementation, migration, and complete PC lifecycle services.'
];

const features = [
  { title: 'Virtual Desktop Infrastructure', text: 'VDI solutions for secure and flexible remote access' },
  { title: 'Collaboration Tools',            text: 'Cloud-based platforms for seamless team collaboration' },
  { title: 'Mobile Device Management',       text: 'Secure management of mobile devices and applications' },
  { title: 'Unified Communications',         text: 'Integrated communication platforms for enhanced productivity' }
];

function DigitalWorkspaceService() {
  return (
    <ServicePage
      title="Digital Workspace Solutions"
      subtitle="Modern, secure, and collaborative digital workplaces"
      img={img}
      imgAlt="Digital Workspace Solutions"
      overview={overview}
      features={features}
      backAnchor="digital-workspace"
    />
  );
}

export default DigitalWorkspaceService;
